import React from 'react'
import Button from '../../shared/Button/Button'
import { useTheme } from '../../context/themeContext'
import useAllSitePage from '../../hooks/useAllSitePage'
import './DiagonalBanner.scss'

const DiagonalBanner = ({ data }) => {
  const { theme } = useTheme()
  const pagesPath = useAllSitePage()
  const { allSitePage: matchPages } = pagesPath

  const title = data?.title
  const variant = data?.variant
  const image = data?.image
  const imageDark = data?.imageDark
  const button = data?.dynamicButton

  return (
    <div
      className={`banner ${variant} container my-5`}
      id={`${variant}-` + data.id}
    >
      <div className={`title container-md col-12 ${
          variant === 'diagonal' ? 'col-md-4' : 'col-md-8'
        }`}
      >
        <h2> {title} </h2>
        {button && (
          <Button
            button={button?.button}
            customButton={button?.customButton}
            classContainer={'button'}
            icon={button?.icon}
            matchPages={matchPages?.nodes}
          />
        )}
      </div>
      <div
        className={`imagen col-12 ${
          variant === 'diagonal' ? 'col-md-8' : 'col-md-4'
        }`}
      >
        {image?.url && (
          <img
            src={theme === 'dark' && imageDark ? imageDark?.url : image?.url}
            alt={title}
          />
        )}
      </div>
    </div>
  )
}

export default DiagonalBanner